import { Text, TextProps, Tooltip, TooltipProps } from '@mantine/core';
import React from 'react';

interface UnderlineTooltipProps {
  label: React.ReactNode;
  children: React.ReactNode;
  size?: TextProps['size'];
  fw?: TextProps['fw'];
  c?: TextProps['c'];
  multiline?: boolean;
  position?: TooltipProps['position'];
  focusable?: boolean;
}

export function UnderlineTooltip({
  label,
  children,
  size = 'md',
  fw = 600,
  c = 'gray.10',
  multiline = false,
  position,
  focusable = false,
}: UnderlineTooltipProps) {
  return (
    <Tooltip
      label={label}
      multiline={multiline}
      maw={multiline ? 320 : undefined}
      position={position}
      events={focusable ? { hover: true, focus: true, touch: true } : undefined}
    >
      <Text
        fw={fw}
        size={size}
        c={c}
        tabIndex={focusable ? 0 : undefined}
        // A tap that opens the tooltip shouldn't also toggle an accordion it sits in
        onClick={focusable ? event => event.stopPropagation() : undefined}
        style={{
          borderBottom: '1px dotted var(--mantine-color-gray-10)',
          display: 'inline-block',
        }}
      >
        {children}
      </Text>
    </Tooltip>
  );
}
